import { render, staticRenderFns } from "./dashboard-status-tab-small.vue?vue&type=template&id=7365c79e"
import script from "./dashboard-status-tab-small.vue?vue&type=script&lang=js"
export * from "./dashboard-status-tab-small.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports